export const Constants = {
	MAXIMUM_INTEGER_VALUE: 2147483647,
	MINIMUM_INTEGER_VALUE: -2147483648,
	FIELD_OPS_NO_LICENCE_ERROR: "User does not have a licence for Field Ops",
	NO_PERMISSION_TO_PAGE: "You do not have permission to this page",
	MAX_MASKING_DURATION: 2147483647,
	MAX_EXPECTED_FREQUENCY: 35791394 // Due to the input being in minutes but the value being saved in seconds, the max value for this input must be (int.maxValue / 60)
} as const;

export const AreaDetailsIndexValues = {
	CONTACTS: 0,
	SCHEDULES: 1,
	NOTES: 2,
	HISTORY: 3,
} as const;

export const GenericTableConstants = {
	SortDirectionAscending: "ascending",
	SortDirectionDescending: "descending",
	MAX_SIZE_FOR_TEXT_CONTROL: 50
} as const;

export const RulesEngineConstants = {
	TRIGGER_PRIORITY_LESS_THAN_EQUALS_ID: 10,
	TRIGGER_PRIORITY_GREATER_THAN_EQUALS_ID: 11
} as const;

export const TourSetUpConstants = {
	MaxCamerasAllowedPerTour: 500
}

export const ActionPlanConstants = {
	ACTION_PLAN_TITLE_MAX_LENGTH: 150
} as const
